import { supabase } from '@/lib/supabase';
import { toast } from 'react-hot-toast';

export function GoogleSignIn() {
  const handleGoogleLogin = async () => {
    try {
      const baseUrl = import.meta.env.VITE_SUPABASE_URL;
      const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;
      const response = await fetch(`${baseUrl}/auth/v1/settings`, {
        headers: { apikey: publishableKey },
      });
      if (!response.ok) throw new Error('Could not verify Google sign-in configuration.');
      const settings = await response.json() as { external?: { google?: boolean } };
      if (settings.external?.google !== true) {
        toast.error('Google sign-in is not enabled for Enerlectra yet. The project administrator must configure the Google OAuth client in Supabase.');
        return;
      }

      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          queryParams: { prompt: 'select_account' },
          redirectTo: window.location.origin,
        },
      });
      if (error) toast.error(`Google sign-in failed: ${error.message}`);
    } catch (cause) {
      toast.error(cause instanceof Error ? cause.message : 'Google sign-in could not be started.');
    }
  };

  return (
    <button type="button" onClick={handleGoogleLogin} className="button button-light google-button full-button" aria-label="Continue with Google">
      <svg aria-hidden="true" viewBox="0 0 48 48" width="18" height="18">
        <path fill="#4285F4" d="M43.6 24.5c0-1.4-.1-2.8-.4-4.1H24v7.8h11a9.4 9.4 0 0 1-4.1 6.2v5.1h6.7c3.9-3.6 6-8.8 6-15z"/>
        <path fill="#34A853" d="M24 44c5.5 0 10.1-1.8 13.5-4.9l-6.7-5.1c-1.8 1.2-4.1 2-6.8 2-5.2 0-9.6-3.5-11.2-8.2H5.9v5.3A20 20 0 0 0 24 44z"/>
        <path fill="#FBBC05" d="M12.8 27.8a12 12 0 0 1 0-7.6v-5.3H5.9a20 20 0 0 0 0 18.2z"/>
        <path fill="#EA4335" d="M24 12c3 0 5.7 1 7.8 3l5.8-5.8C34.1 5.9 29.5 4 24 4A20 20 0 0 0 5.9 14.9l6.9 5.3C14.4 15.5 18.8 12 24 12z"/>
      </svg>
      <span>Continue with Google</span>
    </button>
  );
}
